import { fetchSubscriptions } from './fetchSubscriptions';
import { useQuery } from '@tanstack/react-query';
import { GlobalReactQueryOptions } from '../../config';

const SUBSCRIPTIONS_CACHE_KEY = 'subscriptions';

export const useFetchSubscriptions = (productId: string, enabled: boolean) => {
    return useQuery([SUBSCRIPTIONS_CACHE_KEY, productId], () => fetchSubscriptions(productId), {
        ...GlobalReactQueryOptions,
        enabled,
        staleTime: 5 * 60 * 1000
    });
};
